module.exports = __webpack_public_path__ + "img/5L.33b6971f.png";